export interface IDossierRequest {
  mailbox: string;
  dossierRequestChannel: string;
  redirectPGA: string;
  redirectWebMail: string;
}

export class DossierRequest implements IDossierRequest {
  constructor(public mailbox: string, public dossierRequestChannel: string, public redirectPGA: string, public redirectWebMail: string) {}
}

export interface IDossierResponse {
  dossierIdsId?: number;
  dossierCreationResult?: boolean;
  redirectToIDS?: string;
}

export class DossierResponse implements IDossierResponse {
  constructor(public dossierIdsId?: number, public dossierCreationResult?: boolean, public redirectToIDS?: string) {}
}
